import { Expose } from "class-transformer";

export class UpdateExpenseTypeDto {
  @Expose()
  name: string;

  @Expose()
  accountingAccountId?: string;
}
